// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"355":"3115e875","453":"d8cd2a23"}[chunkId] + ".chunk.js";
};